/**
 * @desc api 请求
 * @time 2023-07-31 15:58:40
 * @user simxin
 */

import axios, { AxiosRequestConfig } from 'axios';
import { getProxyCsrfCode } from '@src/utils/cookies';

/**
 * @desc 主页基础接口
 * @document https://tapd.woa.com/qcloud_cdn_inner/markdown_wikis/show/#1210145441002523471
 */
export async function trtcCGIRequest<
  T extends keyof Application.TrtcCGIRequest.API,
>(
  path: T,
  data: Application.TrtcCGIRequest.API[T]['req']['Body'],
  header = {},
): Promise<Application.TrtcCGIRequest.API[T]['res']> {
  const baseUrl = `${window.AVAPI_TRTC_HOST}`;
  const url = `${baseUrl}/${path}`;
  return await avFetch<Application.TrtcCGIRequest.API[T]['res']>({
    url,
    data,
    headers: {
      ...header,
      'x-csrfcode': getProxyCsrfCode(),
      'x-href': window.location.href,
    },
  });
}

/**
 * @desc 控制台基础接口
 */
export async function adminAPIRequest<
  T extends keyof Application.AdminRequest.API,
>(
  path: T,
  data: Application.AdminRequest.API[T]['req']['Body'],
): Promise<Application.AdminRequest.API[T]['res']> {
  const baseUrl = `${window.AVAPI_TRTC_HOST}`;
  const url = `${baseUrl}/${path}`;
  return await avFetch<Application.AdminRequest.API[T]['res']>({
    url,
    data,
  });
}

/**
 * @desc 转发接口
 */
export async function proxyAPIRequest(data: any): Promise<any> {
  const url = `${window.AVAPI_TRTC_HOST}/common/capi`;
  return await avFetch({
    url,
    data,
    headers: {
      'x-csrfcode': getProxyCsrfCode(),
      'x-href': window.location.href,
    },
  });
}

export async function avFetch<T>({
  url,
  data,
  headers = {},
}: {
  url: string;
  data: { [key: string]: any };
  headers?: { [key: string]: any };
}) {
  const axiosConfig: AxiosRequestConfig = {
    method: 'post',
    url,
    data,
    headers,
    withCredentials: true,
  };
  return (await axios(axiosConfig)
    .then(res => res.data)
    .catch(err => ({
      code: 500,
      message: err.message,
    }))) as T;
}
